import {useInteractionContext} from "../model/InteractionContext";

export default function Loader()
{
    const {isLoading} = useInteractionContext();
    return isLoading? <div className="loader"  /> : <></>
}